import { type FC } from "react";
import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import * as styles from "./styles.css";

type Props = {
  shareUrl: string;
};

export const XShareLink: FC<Props> = ({ shareUrl }) => {
  return (
    <a
      className={styles.link}
      data-ga-action="assess_result__sns_x_share"
      href={shareUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className={styles.iconWrapper}>
        <LazyLoadImage
          src="/images/user_frontend/global/icon/icn_sns_x.svg"
          alt="Xのアイコン"
          width={24}
          height={24}
        />
      </div>
      でシェアする
    </a>
  );
};
